import React from 'react';
import { useNavigate } from 'react-router-dom';

// 1. Ferris Wheel / Fun Fair Ride Icon matching reference image
export const FunFairIcon: React.FC = () => (
  <svg
    className="w-10 h-10 sm:w-11 sm:h-11 shrink-0"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* A-frame support legs */}
    <path
      d="M13 39L22 21L31 39"
      stroke="#111827"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9 39H35" stroke="#111827" strokeWidth="2.5" strokeLinecap="round" />
    {/* Outer wheel rim */}
    <circle cx="22" cy="19" r="14" stroke="#111827" strokeWidth="2.5" />
    {/* Inner ring */}
    <circle cx="22" cy="19" r="7" stroke="#F97316" strokeWidth="1.5" strokeDasharray="3 2" />
    {/* Center hub */}
    <circle cx="22" cy="19" r="2.8" fill="#F97316" stroke="#111827" strokeWidth="1.5" />
    {/* Spokes */}
    <line x1="22" y1="5" x2="22" y2="33" stroke="#111827" strokeWidth="1.5" />
    <line x1="8" y1="19" x2="36" y2="19" stroke="#111827" strokeWidth="1.5" />
    <line x1="12.1" y1="9.1" x2="31.9" y2="28.9" stroke="#111827" strokeWidth="1.5" />
    <line x1="31.9" y1="9.1" x2="12.1" y2="28.9" stroke="#111827" strokeWidth="1.5" />
    {/* Gondola pods (orange circles with black ring) */}
    <circle cx="22" cy="5" r="2.2" fill="#F97316" stroke="#111827" strokeWidth="1.5" />
    <circle cx="22" cy="33" r="2.2" fill="#F97316" stroke="#111827" strokeWidth="1.5" />
    <circle cx="8" cy="19" r="2.2" fill="#F97316" stroke="#111827" strokeWidth="1.5" />
    <circle cx="36" cy="19" r="2.2" fill="#F97316" stroke="#111827" strokeWidth="1.5" />
    <circle cx="12.1" cy="9.1" r="2.2" fill="#F97316" stroke="#111827" strokeWidth="1.5" />
    <circle cx="31.9" cy="9.1" r="2.2" fill="#F97316" stroke="#111827" strokeWidth="1.5" />
    <circle cx="12.1" cy="28.9" r="2.2" fill="#F97316" stroke="#111827" strokeWidth="1.5" />
    <circle cx="31.9" cy="28.9" r="2.2" fill="#F97316" stroke="#111827" strokeWidth="1.5" />
  </svg>
);

// 2. Burger Icon matching reference image
export const BurgerIcon: React.FC = () => (
  <svg
    className="w-10 h-10 sm:w-11 sm:h-11 shrink-0"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Top Bun */}
    <path
      d="M8 19C8 12.5 14.2 7 22 7C29.8 7 36 12.5 36 19H8Z"
      fill="#F59E0B"
      stroke="#111827"
      strokeWidth="2.5"
      strokeLinejoin="round"
    />
    {/* Sesame seeds */}
    <ellipse cx="16" cy="12" rx="1.2" ry="0.6" fill="#FEF3C7" />
    <ellipse cx="22" cy="10.5" rx="1.2" ry="0.6" fill="#FEF3C7" />
    <ellipse cx="28" cy="13" rx="1.2" ry="0.6" fill="#FEF3C7" />
    {/* Lettuce */}
    <path
      d="M6 20C8.5 18.5 11.5 18.5 14 20C16.5 21.5 19.5 21.5 22 20C24.5 18.5 27.5 18.5 30 20C32.5 21.5 35.5 21.5 38 20"
      stroke="#10B981"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    {/* Melted Cheese */}
    <polygon points="9,22 35,22 22,27" fill="#FBBF24" />
    {/* Steak Patty */}
    <rect x="7" y="24" width="30" height="6.5" rx="3.2" fill="#6B2D05" stroke="#111827" strokeWidth="2.5" />
    {/* Bottom Bun */}
    <path
      d="M9 33.5H35C35 37 31.5 39.5 22 39.5C12.5 39.5 9 37 9 33.5Z"
      fill="#F59E0B"
      stroke="#111827"
      strokeWidth="2.5"
      strokeLinejoin="round"
    />
  </svg>
);

// 3. Beer Mug / Bar Icon matching reference image
export const BeerIcon: React.FC = () => (
  <svg
    className="w-10 h-10 sm:w-11 sm:h-11 shrink-0"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Beer Mug Container */}
    <rect x="11" y="14" width="18" height="21" rx="3" fill="#F59E0B" stroke="#111827" strokeWidth="2.5" />
    {/* Liquid highlight stripes */}
    <line x1="16" y1="19" x2="16" y2="30" stroke="#FEF08A" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="20" y1="19" x2="20" y2="30" stroke="#FEF08A" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="24" y1="19" x2="24" y2="30" stroke="#FEF08A" strokeWidth="1.8" strokeLinecap="round" />
    {/* Mug Handle */}
    <path
      d="M29 18H34C36.2 18 38 19.8 38 22V27C38 29.2 36.2 31 34 31H29"
      stroke="#111827"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    {/* Fluffy white foam */}
    <path
      d="M9.5 14C8.5 12.5 9.8 10 12 10.5C13 8 16.5 8 18 10C19.5 7.5 23.5 7.5 25 10C26.5 8.5 30 8.5 31 11C32.5 10.5 34 12.5 33 14.5H9.5V14Z"
      fill="#FFFFFF"
      stroke="#111827"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

// 4. Ice Creams Icon matching reference style
export const IceCreamVectorIcon: React.FC = () => (
  <svg
    className="w-10 h-10 sm:w-11 sm:h-11 shrink-0"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Waffle Cone */}
    <polygon
      points="13,20 31,20 22,40"
      fill="#F59E0B"
      stroke="#111827"
      strokeWidth="2.5"
      strokeLinejoin="round"
    />
    {/* Cone Waffle Texture Lines */}
    <line x1="16" y1="24" x2="26" y2="34" stroke="#D97706" strokeWidth="1.6" strokeLinecap="round" />
    <line x1="28" y1="24" x2="18" y2="34" stroke="#D97706" strokeWidth="1.6" strokeLinecap="round" />
    <line x1="20" y1="20" x2="25" y2="28" stroke="#D97706" strokeWidth="1.6" strokeLinecap="round" />
    <line x1="24" y1="20" x2="19" y2="28" stroke="#D97706" strokeWidth="1.6" strokeLinecap="round" />

    {/* Ice Cream Swirls / Scoops */}
    <path
      d="M12 20C11 16 13.5 12 17 11C18 7.5 22.5 6.5 25 8.5C28.5 7.5 32 11 30.5 16C32.5 17.5 32 20 29.5 21C27 22 15 22 12 20Z"
      fill="#FEF08A"
      stroke="#111827"
      strokeWidth="2.5"
      strokeLinejoin="round"
    />

    {/* Swirl Top Highlight */}
    <path
      d="M17 14C19 10 24 10 26 12C28 13.5 27 16 25 17C23 18 19 17 17 14Z"
      fill="#FDE047"
    />

    {/* Cadbury 99 Flake stick */}
    <rect
      x="25.5"
      y="5"
      width="3.6"
      height="14"
      rx="1.2"
      transform="rotate(22 25.5 5)"
      fill="#78350F"
      stroke="#111827"
      strokeWidth="2"
    />
    <line x1="29" y1="9" x2="31" y2="15" stroke="#92400E" strokeWidth="1" strokeLinecap="round" />
  </svg>
);

// 5. Loaded Fries Icon (kept for backwards compatibility)
export const FriesIcon: React.FC = () => (
  <svg
    className="w-10 h-10 sm:w-11 sm:h-11 shrink-0"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Golden fries sticks */}
    <rect x="13" y="9" width="3.2" height="17" rx="1.2" transform="rotate(-12 13 9)" fill="#FBBF24" stroke="#111827" strokeWidth="1.5" />
    <rect x="19.5" y="6" width="3.5" height="19" rx="1.2" fill="#F59E0B" stroke="#111827" strokeWidth="1.5" />
    <rect x="26.5" y="8" width="3.2" height="18" rx="1.2" transform="rotate(14 26.5 8)" fill="#FBBF24" stroke="#111827" strokeWidth="1.5" />
    <rect x="16" y="11" width="2.8" height="14" rx="1" transform="rotate(-4 16 11)" fill="#FEF08A" stroke="#111827" strokeWidth="1" />
    <rect x="23.5" y="10" width="2.8" height="15" rx="1" transform="rotate(6 23.5 10)" fill="#FEF08A" stroke="#111827" strokeWidth="1" />
    {/* Red Fry Carton */}
    <path
      d="M10 20L13.5 38H30.5L34 20C30 22.5 26.5 20.5 22 21.8C17.5 20.5 14 22.5 10 20Z"
      fill="#EF4444"
      stroke="#111827"
      strokeWidth="2.5"
      strokeLinejoin="round"
    />
    {/* Shadow detail line */}
    <path d="M13.5 26C18 28 26 28 30.5 26" stroke="#B91C1C" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const QuickInfoBar: React.FC = () => {
  const navigate = useNavigate();

  const features = [
    {
      id: 'rides',
      icon: <FunFairIcon />,
      title: 'FUN FAIR RIDES',
      description: 'Great fun for the kids right by the waves!',
      onClick: () => navigate('/about'),
    },
    {
      id: 'bites',
      icon: <BurgerIcon />,
      title: 'AWARD-WINNING QUICK BITES',
      description: 'Steak burgers & footlong hot dogs served fast.',
      onClick: () => navigate('/menu'),
    },
    {
      id: 'bar',
      icon: <BeerIcon />,
      title: 'WELL-STOCKED BAR',
      description: 'Cold draft beers, ciders, wine & refreshing seaside cocktails.',
      onClick: () => navigate('/menu?category=alcohol'),
    },
    {
      id: 'ice-creams',
      icon: <IceCreamVectorIcon />,
      title: 'ICE CREAMS',
      description: 'Whippy cones, flakes, tubs & delicious toppings!',
      onClick: () => navigate('/menu?category=donuts'),
    },
  ];

  return (
    <section className="bg-[#EEEFE9] py-6 sm:py-8 border-b border-[#dde0d5]" id="features-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3.5 sm:gap-4 lg:gap-5">
          {features.map((item) => (
            <div
              key={item.id}
              onClick={item.onClick}
              className="bg-[#F8F9F6] hover:bg-white rounded-2xl p-4 sm:p-5 border border-[#dde0d5] shadow-xs hover:shadow-md flex items-center gap-3.5 sm:gap-4 transition-all duration-200 cursor-pointer group"
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && item.onClick()}
              title={`Explore ${item.title}`}
            >
              <div className="shrink-0 transition-transform duration-200 group-hover:scale-105">
                {item.icon}
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="font-heading font-black text-sm sm:text-base text-[#000000] uppercase tracking-tight group-hover:text-[#0055DA] transition-colors leading-tight">
                  {item.title}
                </h3>
                <p className="text-xs sm:text-[13px] text-gray-600 mt-0.5 sm:mt-1 font-normal leading-snug">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
